export const WATERFALL_EXPORT_COPY = {
  triggerLabel: 'Export to CSV',
  triggerAriaLabel:
    'Export revenue waterfall to CSV. A download link will be emailed to you.',
  modal: {
    title: 'Export Revenue Waterfall CSV',
    body: "We'll send a download link to your email. This may take a few minutes.",
    submitLabel: 'Export',
    cancelLabel: 'Cancel'
  },
  notifications: {
    success:
      "We're generating your report. You'll receive an email when it's ready.",
    error: 'Failed to export revenue waterfall'
  },
  docs: {
    label: 'Learn more',
    href: 'https://docs.sequencehq.com/revenue-recognition/overview'
  }
} as const
